import React from 'react';

import checkIcon from '../../../../assets/icons/check/check.svg';

interface BenefitItemProps {
    text: string;
}

const BenefitItem: React.FC<BenefitItemProps> = ({ text }) => {
    return (
        <div className="flex items-center gap-2 text-gray-600">
            <img src={checkIcon} alt="check" className="w-[12px] h-[12px] flex-shrink-0" />
            <span
                className="font-['Noto_Sans'] text-[14px] font-normal leading-[24px] text-[rgba(0,43,102,0.70)] m-0 tracking-normal tabular-nums lining-nums align-bottom"
            >
                {text}
            </span>
        </div>
    );
};

export default BenefitItem;
